module.exports = __webpack_public_path__ + "media/img/main_bg-28a92019965ffd91161b5f491c915351.jpg";